<app-recap [agentPage]="true"></app-recap>
<ui-table
        #companiesTable
        [table-title]="'Società iscritte'"
>
    <ng-template #customHeader>
        <tr>
            <th>Nome società</th>
            <th>Stato</th>
            <th>Attivazione</th>
        </tr>
    </ng-template>

    <ng-template #customRow let-row="row">
        <tr>
            <td>
                {{ row.name }}
            </td>
            <td>
                {{ translateStatus(row.status) }}
            </td>
            <td>
                {{ formatDateForTable(row.createdAt) }}
            </td>
        </tr>
    </ng-template>
</ui-table>

<ui-table
    #pendingCompaniesTable
    [table-title]="'Società in attesa di onboarding'"
>
    <ng-template #customHeader>
        <tr>
            <th>Nome società</th>
            <th>Stato</th>
            <th>Attivazione</th>
            <th scope="col" class="d-flex justify-content-end pe-5"> Azioni</th>
        </tr>
    </ng-template>

    <ng-template #customRow let-row="row">
        <tr>
            <td>
                {{ row.name }}
            </td>
            <td>
                {{ translateStatus(row.status) }}
            </td>
            <td>
                {{ formatDateForTable(row.createdAt) }}
            </td>
            <td>
                <div class="d-flex justify-content-end">
                    <a class="btn welldone-btn-gray" [routerLink]="['/companies/' + row.id + '/settings']">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" class="bi bi-pencil" viewBox="0 0 16 16">
                            <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                        </svg>
                    </a>
                </div>
            </td>
        </tr>
    </ng-template>
</ui-table>
